import * as Actions from 'FormsUI/actions/BetaOptIn';
export function betaOptIn(state = {}, action) {
  switch (action.type) {
    case Actions.CHANGE_OPT_IN_STATUS:
      return Object.assign({}, state, {
        [action.payload.name]: action.payload.status
      });
    default:
      return state;
  }
}